<template>
  <div :class="rootClass">
    <p :class="`${rootClass}__title`">{{ title }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      rootClass: 'vehicle-card-section'
    }
  }
}
</script>

<style lang="scss">
.vehicle-card-section {
  $root-class: &;

  margin-top: 2rem;
  font-size: 0.875rem;
  line-height: 1.2;
  font-weight: 300;

  &__title {
    font-size: 0.875rem;
    line-height: 1.2;
    font-weight: 500;
  }
}
</style>
